// Danh mục ngôn ngữ hệ thống — 1 nguồn sự thật cho CẢ Core + SaaS + console.
//
// Thêm ngôn ngữ mới (vd tiếng Pháp cho Quebec) = thêm 1 dòng ở đây + dịch file .po.
// KHÔNG phải sửa component nào: quy tắc số nhiều / giống / ngày / tiền đều lấy từ
// `Intl` native của trình duyệt theo mã locale, mình không tự viết luật.
//
// ⚠️ `code` phải khớp tên thư mục trong cnv-ui/locales/<code>/ và giá trị cột
// meta.users.locale ở BE. Đổi code = mồ côi bản dịch + locale user cũ vô nghĩa.

export const SOURCE_LOCALE = 'vi';

export const LOCALES = [
  { code: 'vi', label: 'Tiếng Việt', englishLabel: 'Vietnamese', intl: 'vi-VN' },
  { code: 'en', label: 'English', englishLabel: 'English', intl: 'en-CA' },
  // fr-CA: thị trường Canada dính Quebec (Bill 96 buộc tiếng Pháp cho phần mềm thương mại).
  { code: 'fr', label: 'Français', englishLabel: 'French', intl: 'fr-CA' },
  // es-419 = tiếng Tây Ban Nha Mỹ Latinh, cùng hướng thị trường châu Mỹ với
  // en-CA/fr-CA. Mobile (CNV Connect) bật trước, web dịch sau — mã locale
  // phải hợp lệ ở BE ngay từ đầu, nếu không PATCH /auth/me/locale trả 400.
  { code: 'es', label: 'Español', englishLabel: 'Spanish', intl: 'es-419' },
];

export const LOCALE_CODES = LOCALES.map((l) => l.code);

export function isSupportedLocale(code) {
  return LOCALE_CODES.includes(code);
}

export function getLocaleMeta(code) {
  return LOCALES.find((l) => l.code === code) || LOCALES[0];
}

/**
 * Chuẩn hoá thứ gì đó thành mã locale hợp lệ.
 * Nhận cả 'en-CA', 'en_US', 'EN' → 'en'. Không khớp → null (để caller tự quyết fallback).
 */
export function normalizeLocale(raw) {
  if (!raw || typeof raw !== 'string') return null;
  const base = raw.trim().toLowerCase().replace('_', '-').split('-')[0];
  return isSupportedLocale(base) ? base : null;
}
